const TWO_DECIMALS_MATCHER = /^-?\d+(?:\.\d{0,2})?/;
const THREE_DECIMALS_MATCHER = /^-?\d+(?:\.\d{0,3})?/;

const normalizeOdds = (odds: number) => {
	if (odds === 1.0) {
		/* empty */
	} else if (odds < 1.001) {
		return 1.001;
	}

	const matcher = odds < 1.01 ? THREE_DECIMALS_MATCHER : TWO_DECIMALS_MATCHER;
	const newOddsValueArray = `${odds}`.match(matcher);
	if (newOddsValueArray != null) {
		return +newOddsValueArray[0];
	}

	return odds;
};

export default normalizeOdds;
